import { ProductsService } from '@/services/products.service';
import { useQuery } from '@tanstack/react-query';

export const useFetchProductById = (id: string) => {
  const {
    data: product,
    refetch,
    error,
    isPending: isLoadingProductDetail,
  } = useQuery({
    queryKey: [`get-product-${id}`],
    queryFn: async () => ProductsService.getProductById(id),
  });

  return { product, refetch, error, isLoadingProductDetail };
};
